import(/* webpackMode: "eager" */ "/home/runner/work/frontend-platform/frontend-platform/apps/web-ui/app/login/page.tsx");
